import React, { useState } from "react";
import contactimg from "../img/contactimg.png";
import "./Contact.css";
import CTA from "../components/CTA";
import { Call, Email } from "@mui/icons-material";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [message, setMessage] = useState("");


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const sendSuperbText = async (e) => {
    e.preventDefault(); // Prevent form submission from refreshing the page
    setMessage(""); // Reset message before sending a new request
 
    try {
      const response = await fetch(
        "https://us-central1-luxuryspainproperties.cloudfunctions.net/sendSuperbText",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            message: formData.message,
          }), // Send all form data
        }
      );

      const data = await response.json(); // Now expecting JSON

      if (response.ok) {
        setMessage(data.message); // Display success message
        
      } else {
        setMessage(data.error); // Display error message
       
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Error sending email: " + error.message); // Log the error message
      
    }
  };

  return (
    <div className="Contact">
      <div className="Contact__containers">
        <div className="Contact__txt">
          <h1>Contact</h1>
          <div className="Contact__txt__desc">
            <p>Let’s talk about your project</p>
          </div>

          <form onSubmit={sendSuperbText}>
            <div className="Contact__input__name">
              <div className="Contact__input__label">
                <p>Name</p>
              </div>
              <div className="Contact__input">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="Contact__input__email">
              <div className="Contact__input__label">
                <p>E-mail</p>
              </div>
              <div className="Contact__input">
                <input
                  type="email"
                  name="email"
                  placeholder="E-mail"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            <div className="Contact__input__message">
              <div className="Contact__input__label">
                <p>Message</p>
              </div>
              <div className="Contact__input__message__input">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>
            </div>
            <div className="Contact__cta__align">
              <CTA label="Send message" type="submit" />
            </div>
            <div className="Successmsg">
            <p>{message}</p> 
            </div>
          
          </form>
          <div className="Contact__icons">
            <div className="Contact__icons__Phone">
              <div className="Contact__icons__Phone__MUI">
                <Call />
              </div>
              <div className="Contact__icons__Phone__txt">
                <p>+1 (346)225-7360</p>
              </div>
            </div>
            <div className="Contact__icons__Email">
              <div className="Contact__icons__Email__MUI">
                <Email />
              </div>
              <div className="Contact__icons__Email__txt">
                <p>info@luxuryspainproperties.com</p>
              </div>
            </div>
          </div>
        </div>
        <div className="Contact__img">
          <img src={contactimg} alt="Contact" />
        </div>
      </div>

    </div>
  );
}

export default Contact;
